import DescriptionView from './DescriptionView'

export default DescriptionView
